import type { CompleteFieldSelector } from '@/types/fields-api.model';
import { ManagerBalance } from '@/types/manager.model';

const MANAGER_BALANCE_FIELDS_MINIMAL = {
  negativeBalance: true,
  maxBalance: true,
} as const;

const MANAGER_BALANCE_FIELDS_FULL: CompleteFieldSelector<ManagerBalance> = {
  ...MANAGER_BALANCE_FIELDS_MINIMAL,
} as const;

export const MANAGER_BALANCE_FIELDS = {
  MINIMAL: MANAGER_BALANCE_FIELDS_MINIMAL,
  FULL: MANAGER_BALANCE_FIELDS_FULL,
} as const;
